import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ILoyaltyTransactionV2 } from 'generated/graphql-gateway';
import { LoyaltyUser } from 'state/loyalty/hooks/types';

import { IUserState } from './user.types';

export const initialState: IUserState = {
  loyaltyUser: null,
  loyaltyLoading: false,
  loyaltyUserTransactions: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<LoyaltyUser | null>) => {
      return {
        ...state,
        loyaltyUser: payload,
      };
    },
    setLoyaltyLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loyaltyLoading = payload;
    },
    setUserTransactions: (state, { payload }: PayloadAction<ILoyaltyTransactionV2[]>) => {
      return {
        ...state,
        loyaltyUserTransactions: payload,
      };
    },
  },
});
